export const FETCH_LOGIN_DATA_REQUEST = 'FETCH_LOGIN_DATA_REQUEST';
export const FETCH_LOGIN_DATA_SUCCESS = 'FETCH_LOGIN_DATA_SUCCESS';
export const FETCH_LOGIN_DATA_FAILURE = 'FETCH_LOGIN_DATA_FAILURE';
export const TEST='TEST';
export const USER_DETAILS='USER_DETAILS';